import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import * as fromActions from './app.actions';
// import { Router } from '@angular/router';
// import { RouterFacade } from '@cigna/shared/angular/core/router-state-data-access';
import { checkError } from '@cigna/cigna-for-brokers/shared/util';
import { AppFacade } from './app.facade';
import { AppService } from './app.service';
// import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';

@Injectable()
export class AppEffects {
  // getAgencyList$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(fromActions.getAgencyList),

  //     switchMap(() =>
  //       this._service.getAgencyList().pipe(
  //         // eslint-disable-next-line sonarjs/no-identical-functions
  //         tap((payload: AgencyListRes) => {
  //           if (payload.metadata && payload.metadata.outcome) {
  //             const error: ServiceError = checkError(payload);
  //             // this.analytics.trackServiceError(
  //             //   {},
  //             //   'Get Agency Details:GET',
  //             //   error,
  //             //   'Error on Get Agency Details:GET',
  //             // );
  //           }
  //         }),
  //         switchMap((payload: AgencyListRes) => {
  //           const actions = [];
  //           if (
  //             payload.metadata &&
  //             payload.metadata.outcome &&
  //             payload.metadata.outcome.status === 200
  //           ) {
  //             actions.push(
  //               fromActions.getAgencyListSuccess({
  //                 payload,
  //               }),
  //             );
  //             return actions;
  //           }
  //           const error: ServiceError = checkError(payload);
  //           return [fromActions.getAgencyListFailure({ error })];
  //         }),
  //         catchError((error) =>
  //           of(
  //             fromActions.getAgencyListFailure({
  //               error: error.error.metadata ? checkError(error.error) : error,
  //             }),
  //           ),
  //         ),
  //       ),
  //     ),
  //   ),
  // );

  // getAgencyListFailure$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(fromActions.getAgencyListFailure),
  //       tap(({ error }) => {
  //         // this.analytics.trackServiceError(
  //         //   {},
  //         //   'getAgencyListFailure:GET',
  //         //   error,
  //         //   'Error getting getAgencyListFailure.',
  //         // );
  //       }),
  //     ),
  //   { dispatch: false },
  // );

  // postAffirm$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(fromActions.postAffirm),
  //     // /* eslint-disable sonarjs/cognitive-complexity, no-empty-pattern */
  //     switchMap(({ request }) =>
  //       this._service.postAffirm(request).pipe(
  //         // eslint-disable-next-line sonarjs/no-identical-functions
  //         tap((payload: PostAffirmSuccessRes) => {
  //           if (payload.metadata && payload.metadata.outcome) {
  //             const error: ServiceError = checkError(payload);
  //             // this.analytics.trackServiceError(
  //             //   {},
  //             //   'POST: Post Affirm',
  //             //   error,
  //             //   'Error on While making postAffirm:POST',
  //             // );
  //           }
  //         }),
  //         switchMap((payload: PostAffirmSuccessRes) => {
  //           const actions = [];
  //           if (
  //             payload.metadata &&
  //             payload.metadata.outcome &&
  //             payload.metadata.outcome.status === 200
  //           ) {
  //             actions.push(
  //               fromActions.postAffirmSuccess({
  //                 request,
  //                 payload,
  //               }),
  //             );
  //             return actions;
  //           }
  //           const error: ServiceError = checkError(payload);
  //           return [fromActions.postAffirmFailure({ error })];
  //         }),

  //         catchError((error) =>
  //           of(
  //             fromActions.postAffirmFailure({
  //               error: error.error.metadata
  //                 ? checkError(error.error)
  //                 : { message: error.message, status: 500, errObject: error },
  //             }),
  //           ),
  //         ),
  //       ),
  //     ),
  //   ),
  // );

  // postAffirmFailure$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(fromActions.postAffirmFailure),
  //       tap(({ error }) => {}),
  //     ),
  //   { dispatch: false },
  // );

  getKeepAlive$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.getKeepAlive),
      /* eslint-disable sonarjs/cognitive-complexity, no-empty-pattern */

      switchMap(() =>
        this._service.getKeepAlive().pipe(
          // eslint-disable-next-line sonarjs/no-identical-functions
          tap((payload: { metadata?: { outcome?: unknown } }) => {
            if (payload.metadata && payload.metadata.outcome) {
              checkError(payload);
            }
          }),
          switchMap(() => {
            const actions = [];
            actions.push(fromActions.getKeepAliveSuccess());
            return actions;
          }),
          catchError((error) =>
            of(
              fromActions.getKeepAliveFailure({
                error: error.error.metadata ? checkError(error.error) : error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  getKeepAliveFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromActions.getKeepAliveFailure),
        tap(() => {}),
      ),
    { dispatch: false },
  );

  constructor(
    // private router: Router,
    // private routerFacade: RouterFacade,
    private actions$: Actions,
    private _service: AppService,
    private _appFacade: AppFacade,
  ) {}
}
